import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ModalThemMoi } from "./ModalThemMoi";

export const BtnThemMoi = ({ item }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <button type="button" class="btn btn-border-new" onClick={handleShow}>
        <i class="mdi mdi-plus"></i> Thêm mới
      </button>
      {show && <ModalThemMoi show={show} onHide={handleClose} Id={0} />}
    </>
  );
};
